export const modalStyles = {
  container: {
    position: 'center',
    left: '70%',
    transform: 'translate(45%, 3%)',
    width: '65%',
    height: '95%',      
    border: 'none 1px solid #ccc',
    background: '#25274D',
    overflow: 'auto',
    borderRadius: '4px',
    outline: 'none',
    padding: '5px',  },

  content : {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '1.5rem',
    padding: '0.5rem 0'
  }
}